import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the top on every route change (fixes footer links / nav keeping scroll position).
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
